import { takeLatest, put, call } from "redux-saga/effects";
import { loadKeycloakTokenForNps } from "utils/auth/localStorage";
import { Types, Creators } from "./nps-duck";

export const getState = (state) => state.Nps;

export function* onFetchKeycloakToken() {
  try {
    const keycloakToken = yield call(loadKeycloakTokenForNps);
    if (keycloakToken) {
      yield put(Creators.npsUpdateKeycloakToken(keycloakToken));
    }
  } catch (error) {
    console.error(error);
  }
}

export default function* NpsSagas() {
  yield takeLatest(Types.NPS_GET_KEYCLOAK_TOKEN_ASYNC, onFetchKeycloakToken);
}
